// Mock data for Dane Rose Consulting Website

export const siteConfig = {
  name: "Dane Rose",
  title: "10 X Designer & Consultant",
  tagline: "10 X Design for Sustainable Well-being",
  rate: "$175/hour",
  phone: "415-455-9161",
  email: "dane@mysticallandscapes.com",
  description: "Rearranging time, money, thought and natural resources to create higher yields of sustainable well-being at the personal, relationship, family, community and national level."
};

export const services = [
  {
    id: 1,
    title: "10 X Relationships",
    description: "Transform your personal and professional relationships through conscious chemistry and emotional intelligence. Learn to create deeper connections and sustainable bonds.",
    icon: "Heart"
  },
  {
    id: 2,
    title: "10 X Business",
    description: "Elevate your business through cultural design principles. Optimize operations, enhance team dynamics, and create environments where people and profits thrive together.",
    icon: "TrendingUp"
  },
  {
    id: 3,
    title: "Landscape Design",
    description: "Over 30 years creating mystical landscapes in Marin County. Biodynamic gardening, sustainable design, and spaces that nurture the soul.",
    icon: "Leaf"
  },
  {
    id: 4,
    title: "Eco Village & Microcultures",
    description: "Design intentional communities and microcultures that foster well-being, sustainability, and meaningful human connection.",
    icon: "Home"
  },
  {
    id: 5,
    title: "Nonprofit Consulting",
    description: "Strategic guidance for organizations focused on social impact. From Happiness Data to community initiatives, amplify your mission.",
    icon: "Users"
  },
  {
    id: 6,
    title: "10 X Hotels & Hospitality",
    description: "Create transformative hospitality experiences that blend biophilic design, wellness, and exceptional guest journeys.",
    icon: "Building"
  }
];

export const books = [
  {
    id: 1,
    title: "Magical Relationships",
    description: "A guide to creating conscious chemistry and deeper connections.",
    link: "https://www.amazon.com/dp/B09QFDQRYW"
  },
  {
    id: 2,
    title: "Faces of Love",
    description: "Exploring the many dimensions of love and human connection.",
    link: "https://www.amazon.com/dp/B0CMVBX79J"
  },
  {
    id: 3,
    title: "An Introduction to Life",
    description: "Foundational wisdom for navigating life's journey.",
    link: "https://www.amazon.com/dp/B09TN3GZ8D"
  },
  {
    id: 4,
    title: "101 Choices on my Path to Well-Being",
    description: "Practical decisions that lead to sustainable happiness.",
    link: "https://www.amazon.com/101-Choices-Path-Well-Being-Estonian/dp/0557041341"
  },
  {
    id: 5,
    title: "Celebrating Beauty",
    description: "An exploration of aesthetics and the art of appreciation.",
    link: "https://www.amazon.com/Celebrating-Beauty-Dane-Colby/dp/0557155983"
  },
  {
    id: 6,
    title: "Successfully Landscaping Your Marin Home",
    description: "Expert guidance for creating beautiful Marin landscapes.",
    link: "https://www.amazon.com/dp/1466426489"
  }
];

export const ventures = [
  {
    id: 1,
    name: "Mystical Landscapes",
    description: "Marin's premier landscape design and installation company since 1990.",
    link: "https://www.mysticallandscapes.com/"
  },
  {
    id: 2,
    name: "Happiness Data",
    description: "A 501(c)(3) nonprofit measuring core metrics of well-being and developing personal protocols for sustainable happiness.",
    link: "https://happinessdata.org/"
  },
  {
    id: 3,
    name: "10X Living",
    description: "A community and resource hub for exponential personal growth and transformation.",
    link: "https://10xliving.org/"
  }
];

export const testimonials = [
  {
    id: 1,
    quote: "Successfully Landscaping Your Marin Home helped me tremendously in gaining insight about landscaping and answered all the questions and concerns I had about improving my yard on a budget that was right for me.",
    author: "Amazon Review",
    rating: 5
  },
  {
    id: 2,
    quote: "Dane's approach to cultural design has transformed how I think about my relationships and business. His wisdom is practical and profound.",
    author: "Consulting Client",
    rating: 5
  }
];

export const images = {
  hero: "https://images.unsplash.com/photo-1627687038907-cb8b463cbc92?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHw0fHxteXN0aWNhbCUyMGdhcmRlbnxlbnwwfHx8fDE3NjY1Nzc2ODZ8MA&ixlib=rb-4.1.0&q=85",
  garden1: "https://images.unsplash.com/photo-1616415326996-23d7665716ac?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwxfHxteXN0aWNhbCUyMGdhcmRlbnxlbnwwfHx8fDE3NjY1Nzc2ODZ8MA&ixlib=rb-4.1.0&q=85",
  garden2: "https://images.unsplash.com/photo-1739139697183-8abdc2696a2c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwyfHxteXN0aWNhbCUyMGdhcmRlbnxlbnwwfHx8fDE3NjY1Nzc2ODZ8MA&ixlib=rb-4.1.0&q=85",
  texture1: "https://images.unsplash.com/photo-1763392970603-b8537d827975?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwxfHxvcmdhbmljJTIwbmF0dXJlJTIwdGV4dHVyZXN8ZW58MHx8fHwxNzY2NTc3NjkyfDA&ixlib=rb-4.1.0&q=85",
  texture2: "https://images.unsplash.com/photo-1766201025706-a844a0e60cc5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwyfHxvcmdhbmljJTIwbmF0dXJlJTIwdGV4dHVyZXN8ZW58MHx8fHwxNzY2NTc3NjkyfDA&ixlib=rb-4.1.0&q=85",
  texture3: "https://images.unsplash.com/photo-1764230990146-b4d2882f30e0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwzfHxvcmdhbmljJTIwbmF0dXJlJTIwdGV4dHVyZXN8ZW58MHx8fHwxNzY2NTc3NjkyfDA&ixlib=rb-4.1.0&q=85",
  consulting: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwxfHxidXNpbmVzcyUyMGNvbnN1bHRpbmd8ZW58MHx8fHwxNzY2NTc3NzA0fDA&ixlib=rb-4.1.0&q=85",
  lifestyle: "https://images.pexels.com/photos/2977565/pexels-photo-2977565.jpeg"
};
